import { hashKey, useQuery } from '@tanstack/react-query';
import z from 'zod';

import { CommentListItem } from '@e-origin/contracts';
import { CommentsCriteria, SortDirection } from '@e-origin/shared';

import { apiClient } from '@utils';
import { showErrorToast } from '../showErrorToast';

interface FetchCommentsResponse {
  list: CommentListItem[];
  totalItems: number;
  userMap?: Record<string, string>;
}

export const defaultCommentCriteria: CommentsCriteria = {
  filters: { filterByEntityId: [], filterByEntityParentId: [] },
  sorting: { field: 'updatedAt', direction: SortDirection.DESC },
  includeUserDetails: false,
};

export const useComments = (criteria: CommentsCriteria, enabled = true) =>
  useQuery({
    queryKey: ['comments', hashKey([criteria])],
    enabled,
    queryFn: async (): Promise<FetchCommentsResponse> => {
      try {
        const result = await apiClient.comment.retrieveComments.mutation({ body: { criteria } });
        if (result.status !== 200) throw result.body;
        return {
          list: (result.body.data?.list as CommentListItem[]) ?? [],
          totalItems: result.body.data?.totalItems ?? 0,
          userMap: result.body.data?.userMap ?? {},
        };
      } catch (error) {
        showErrorToast(error, 'Failed to fetch comments');
      }
    },
  });
